__turbopack_context__.v({
  "headerLink": "styles-module__Ri6pyq__headerLink",
  "navigationLink": "styles-module__Ri6pyq__navigationLink",
});
